module.exports = __webpack_public_path__ + "static/img/logo.c4c81b5e.png";